// extracted by mini-css-extract-plugin
export default {"banner":"NotificationBanner_banner__+Ig30","content":"NotificationBanner_content__+iDG1"};